import React from "react";
import cx from "classnames";
import gameDays from "./games.json";
import { Row } from "./Row";
import { useInView } from "react-intersection-observer";
import "./Games.scss";

// one two

export enum Player {
  STUMPAN,
  KNOX,
  ZEGE,
  KAKEL,
  DONNIE,
  JAKE,
  LUDDE,
  CONSI,
  AI,
}

// prettier-ignore
const tips = [
  ["1", "1", "x", "1", "1", "1", "1", "1", "1"], // 1 Mexiko - Sydafrika
  ["2", "2", "2", "2", "2", "1", "2", "1", "2"], // 2 Sydkorea - Tjeckien
  ["x", "1", "x", "x", "2", "2", "1", "1", "1"], // 3 Kanada - Bosnien-Hercegovina
  ["x", "1", "1", "x", "x", "2", "1", "1", "1"], // 4 USA - Paraguay
  ["2", "2", "2", "2", "2", "2", "2", "2", "2"], // 5 Qatar - Schweiz
  ["1", "1", "x", "x", "x", "1", "1", "1", "1"], // 6 Brasilien - Marocko
  ["2", "2", "2", "2", "2", "x", "2", "2", "2"], // 7 Haiti - Skottland
  ["2", "2", "2", "x", "2", "2", "2", "2", "2"], // 8 Australien - Turkiet
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 9 Tyskland - Curaçao
  ["1", "2", "x", "x", "1", "2", "1", "x", "1"], // 10 Nederländerna - Japan
  ["2", "2", "2", "x", "x", "2", "2", "2", "x"], // 11 Elfenbenskusten - Ecuador
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 12 Sverige - Tunisien
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 13 Spanien - Kap Verde
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 14 Belgien - Egypten
  ["2", "x", "2", "2", "2", "2", "2", "2", "2"], // 15 Saudiarabien - Uruguay
  ["1", "x", "x", "1", "2", "2", "1", "x", "1"], // 16 Iran - Nya Zeeland
  ["1", "1", "1", "x", "1", "1", "1", "1", "1"], // 17 Frankrike - Senegal
  ["2", "2", "2", "2", "2", "2", "2", "2", "2"], // 18 Irak - Norge
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 19 Argentina - Algeriet
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 20 Österrike - Jordanien
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 21 Portugal - DR Kongo
  ["1", "x", "1", "x", "1", "x", "1", "1", "1"], // 22 England - Kroatien
  ["1", "1", "1", "1", "1", "x", "1", "1", "1"], // 23 Ghana - Panama
  ["2", "2", "2", "2", "2", "x", "2", "2", "2"], // 24 Uzbekistan - Colombia
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 25 Tjeckien - Sydafrika
  ["1", "1", "1", "1", "1", "1", "x", "1", "1"], // 26 Schweiz - Bosnien
  ["1", "1", "1", "1", "1", "x", "1", "1", "1"], // 27 Kanada - Qatar
  ["1", "x", "x", "1", "1", "x", "1", "2", "1"], // 28 Mexiko - Sydkorea
  ["1", "x", "1", "1", "1", "x", "1", "1", "1"], // 29 USA - Australien
  ["2", "2", "2", "x", "2", "2", "x", "x", "x"], // 30 Skottland - Marocko
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 31 Brasilien - Haiti
  ["x", "1", "x", "x", "1", "2", "1", "x", "1"], // 32 Turkiet - Paraguay
  ["1", "1", "1", "1", "x", "1", "1", "1", "1"], // 33 Nederländerna - Sverige
  ["1", "1", "x", "1", "1", "x", "1", "1", "1"], // 34 Tyskland - Elfenbenskusten
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 35 Ecuador - Curaçao
  ["x", "2", "2", "x", "2", "2", "1", "2", "2"], // 36 Tunisien - Japan
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 37 Spanien - Saudiarabien
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 38 Belgien - Iran
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 39 Uruguay - Kap Verde
  ["2", "2", "2", "2", "x", "2", "2", "2", "2"], // 40 Nya Zeeland - Egypten
  ["1", "1", "x", "1", "1", "1", "1", "1", "1"], // 41 Argentina - Österrike
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 42 Frankrike - Irak
  ["1", "1", "1", "2", "1", "x", "x", "1", "1"], // 43 Norge - Senegal
  ["2", "x", "2", "2", "x", "2", "2", "2", "2"], // 44 Jordanien - Algeriet
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 45 Portugal - Uzbekistan
  ["1", "1", "1", "2", "x", "1", "1", "1", "1"], // 46 England - Ghana
  ["2", "2", "2", "2", "2", "x", "2", "2", "2"], // 47 Panama - Kroatien
  ["1", "2", "1", "1", "1", "x", "1", "1", "1"], // 48 Colombia - DR Kongo
  ["1", "x", "1", "x", "1", "1", "1", "1", "x"], // 49 Schweiz - Kanada
  ["1", "1", "1", "x", "1", "1", "1", "1", "1"], // 50 Bosnien - Qatar
  ["1", "1", "1", "1", "1", "1", "1", "1", "1"], // 51 Marocko - Haiti
  ["2", "2", "2", "2", "2", "2", "2", "2", "2"], // 52 Skottland - Brasilien
  ["x", "2", "2", "x", "1", "2", "x", "2", "2"], // 53 Sydafrika - Sydkorea
  ["2", "x", "x", "x", "x", "x", "x", "1", "2"], // 54 Tjeckien - Mexiko
  ["2", "2", "2", "2", "2", "2", "2", "2", "2"], // 55 Curaçao - Elfenbenskusten
  ["2", "x", "x", "2", "x", "x", "2", "2", "2"], // 56 Ecuador - Tyskland
  ["2", "2", "2", "2", "2", "2", "2", "2", "2"], // 57 Tunisien - Nederländerna
  ["x", "x", "2", "2", "2", "2", "x", "x", "x"], // 58 Japan - Sverige
  ["1", "2", "2", "2", "x", "x", "x", "1", "2"], // 59 Turkiet - USA
  ["1", "x", "1", "x", "1", "1", "x", "x", "x"], // 60 Paraguay - Australien
  ["2", "x", "2", "2", "2", "x", "2", "x", "2"], // 61 Norge - Frankrike
  ["x", "1", "1", "1", "1", "1", "1", "1", "1"], // 62 Senegal - Irak
  ["2", "2", "2", "x", "x", "2", "2", "x", "2"], // 63 Kap Verde - Saudiarabien
  ["2", "2", "x", "2", "2", "x", "x", "x", "2"], // 64 Uruguay - Spanien
  ["2", "2", "2", "2", "x", "x", "2", "2", "2"], // 65 Nya Zeeland - Belgien
  ["x", "1", "1", "1", "x", "1", "x", "1", "x"], // 66 Egypten - Iran
  ["2", "2", "2", "2", "2", "2", "2", "2", "2"], // 67 Panama - England
  ["x", "1", "x", "1", "x", "x", "x", "x", "1"], // 68 Kroatien - Ghana
  ["x", "1", "1", "x", "x", "1", "x", "x", "x"], // 69 DR Kongo - Uzbekistan
  ["2", "2", "x", "2", "1", "2", "x", "2", "2"], // 70 Colombia - Portugal
  ["x", "1", "x", "x", "x", "x", "x", "2", "2"], // 71 Algeriet - Österrike
  ["2", "2", "2", "2", "2", "2", "2", "2", "2"], // 72 Jordanien - Argentina
];

const result: string[] = ["1","1","x","1","x","x","2","1","1","x","1","1","x","x","x","x","1","2","1","1","x","1","1","2","x","1","1","1","1","2","1","2","1","1","x","2","1","x","x","2","1","1","1","2","1","x","2","1","1","1","1","2","1","2","2","1","2","x","1","x","2","1","x","2","2","x","2","1","1","x","x","2"];

export const Games: React.FunctionComponent = () => {
  // const [show, setShow] = useState<boolean>(Store.getValue("showTipsTable"));
  let matchId = -1;

  // const onClick = useCallback(() => {
  //   setShow(!show);
  //   Store.setValue("showTipsTable", !show);
  // }, [show]);

  const [ref, inView] = useInView({
    threshold: 0.2,
  });

  return (
    <div
      className={cx("games", {
        "show-table": true, // show
        "show-header": inView,
      })}
    >
      {/* <div className="button-wrapper"> */}
      {/* <button onClick={onClick}>
          {show ? "Dölj tabell" : "Visa tabell"}
        </button> */}

      {/* <FlipButton onClick={onClick}>
        {show ? "Dölj tabell" : "Visa tabell"}
      </FlipButton> */}
      {/* </div> */}
      <div className="games-top-wrapper">
        <div className="games-top">
          <div className="date-and-name" />

          <div className="games-header">
            <div className="header-names">
              <div className="header-name stumpan">
                <div>Stumpan</div>
              </div>
              <div className="header-name knox">
                <div>Knox</div>
              </div>
              <div className="header-name zege">
                <div>Zege</div>
              </div>
              <div className="header-name kakel">
                <div>Kakel</div>
              </div>
              <div className="header-name donnie">
                <div>Donnie</div>
              </div>
              <div className="header-name jake">
                <div>Jake</div>
              </div>
              <div className="header-name ludde">
                <div>Ludde</div>
              </div>
              <div className="header-name consi">
                <div>Consi</div>
              </div>
              <div className="header-name ai">
                <div>AI</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ul ref={ref}>
        <li className="header-rows">

          <div className="header-cell date-and-name">
            <span />
          </div>
          <div className="header-cell game-cell">
            <span>Stumpan</span>
          </div>
          <div className="header-cell game-cell">
            <span>Knox</span>
          </div>
          <div className="header-cell game-cell">
            <span>Zege</span>
          </div>
          <div className="header-cell game-cell">
            <span>Kakel</span>
          </div>
          <div className="header-cell game-cell">
            <span>Donnie</span>
          </div>
          <div className="header-cell game-cell">
            <span>Jake</span>
          </div>
          <div className="header-cell game-cell">
            <span>Ludde</span>
          </div>
          <div className="header-cell game-cell">
            <span>Consi</span>
          </div>
          <div className="header-cell game-cell">
            <span>AI</span>
          </div>
        </li>

        {gameDays.map((gameDay) =>
          gameDay.games.map((game) => {
            matchId++;
            return (
              <Row
                key={game.game}
                game={game}
                dateString={gameDay.dateString}
                tips={tips[matchId]}
                result={result[matchId]}
              />
            );
          })
        )}

        <li className="games-single-question exodus">
          <div className="date-and-name">
            Uttåg <b>(1p)</b>
          </div>
          <div className="value-wrapper">
            <div className="value-name stumpan">
              <div>16-del</div>
            </div>
            <div className="value-name knox">
              <div>16-del</div>
            </div>
            <div className="value-name zege">
              <div>Semifinal</div>
            </div>
            <div className="value-name kakel">
              <div>16-del</div>
            </div>
            <div className="value-name donnie">
              <div>16-del</div>
            </div>
            <div className="value-name jake">
              <div>16-del</div>
            </div>
            <div className="value-name ludde">
              <div>8-del</div>
            </div>
            <div className="value-name consi">
              <div>16-del</div>
            </div>
            <div className="value-name ai">
              <div>16-del</div>
            </div>
          </div>
        </li>

        <li className="games-single-question exodus">
          <div className="date-and-name">
            Totalt antal mål <b>(2p)</b>
          </div>
          <div className="value-wrapper">
            <div className="value-name stumpan ">
              <div>244</div>
            </div>
            <div className="value-name knox ">
              <div>283</div>
            </div>
            <div className="value-name zege ">
              <div>340</div>
            </div>
            <div className="value-name kakel ">
              <div>265</div>
            </div>
            <div className="value-name donnie ">
              <div>201</div>
            </div>
            <div className="value-name jake ">
              <div>251</div>
            </div>
            <div className="value-name ludde ">
              <div>285</div>
            </div>
            <div className="value-name consi ">
              <div>260</div>
            </div>
            <div className="value-name ai">
              <div>281</div>
            </div>
          </div>
        </li>

        <li className="games-single-question">
          <div className="date-and-name">
            Striker <b>(3p)</b>
          </div>
          <div className="value-wrapper">
            <div className="value-name stumpan ">
              <div>Kane</div>
            </div>
            <div className="value-name knox ">
              <div>Mbappé</div>
            </div>
            <div className="value-name zege ">
              <div>Mbappe</div>
            </div>
            <div className="value-name kakel ">
              <div>Kane</div>
            </div>
            <div className="value-name donnie ">
              <div>Dembele</div>
            </div>
            <div className="value-name jake ">
              <div>Mbappe</div>
            </div>
            <div className="value-name ludde ">
              <div>Mbappé</div>
            </div>
            <div className="value-name consi ">
              <div>Mbappé</div>
            </div>
            <div className="value-name ai ">
              <div>Mbappé</div>
            </div>
          </div>
        </li>

        <li className="games-countries">
          <div className="date-and-name">
            Vinnare <b>(3p)</b>
          </div>
          <div className="game-cell flag stumpan ">🏴󠁧󠁢󠁥󠁮󠁧󠁿</div>
          <div className="game-cell flag knox ">🇫🇷</div>
          <div className="game-cell flag zege">🇳🇱</div>
          <div className="game-cell flag kakel ">🇧🇷</div>
          <div className="game-cell flag donnie ">🇫🇷</div>
          <div className="game-cell flag jake ">🇫🇷</div>
          <div className="game-cell flag ludde ">🇪🇸</div>
          <div className="game-cell flag consi ">🇪🇸</div>
          <div className="game-cell flag ai">🇪🇸</div>
          {/* <div className="game-cell flag consi incorrect">🇧🇷</div> */}
        </li>

        <li className="games-single-question total">
          <div className="date-and-name">Poäng</div>
          <div className="value-wrapper">
            <div className="value-name stumpan">45</div>
            <div className="value-name knox">41</div>
            <div className="value-name zege">44</div>
            <div className="value-name kakel">41</div>
            <div className="value-name donnie">43</div>
            <div className="value-name jake">31</div>
            <div className="value-name ludde">42</div>
            <div className="value-name consi">45</div>
            <div className="value-name ai">45</div>
          </div>
        </li>
      </ul>
    </div>
  );
};
